import React, { useEffect, useState } from "react";
import "../styles/creators.css";
import { useAuth } from "../context/AuthContext";
import {
  joinCreatorProgram,
  isCreator,
} from "../firebase";

const API =
  "https://script.google.com/macros/s/AKfycbzooP2NwtUgAllO-g9bTB42S3oIfbF_kUzspvcX9vIeCKrhFnBvxNkQCt3kuYAFpE13Yg/exec?action=getCreatorsLeaderboard";

function formatWeek(start, end) {
  if (!start || !end) return "";

  const s = new Date(start);
  const e = new Date(end);

  return `${s.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
  })} – ${e.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
  })}`;
}

export default function Creators() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const { user } = useAuth();
  const [creator, setCreator] = useState(false);

  const handleJoinCreator = async () => {
  if (!user) {
    alert("Please login first.");
    return;
  }

  if (creator) {
    alert("You're already an Eyal Creator.");
    return;
  }

  if (
    !window.confirm(
      "Become an Eyal Creator and start earning rewards?"
    )
  ) {
    return;
  }

  await joinCreatorProgram(user.uid);

  setCreator(true);

  alert("🎉 Welcome to the Eyal Creator Program!");
};

  useEffect(() => {
  fetch(API)
    .then((r) => r.json())
    .then((d) => setList(Array.isArray(d) ? d : []))
    .catch(() => setList([]))
    .finally(() => setLoading(false));

  if (user) {
    isCreator(user.uid).then(setCreator);
  }
}, [user]);

  if (loading) {
    return (
      <div className="creators-page">
        <p className="center">Loading Creator Program...</p>
      </div>
    );
  }

  return (
    <div className="creators-page">

      <h2 className="creators-title">
        🏆 Eyal Creator Program
      </h2>

      <p className="creator-description">
        Become an Eyal Creator and earn rewards by sharing useful local
        updates from your area.
      </p>

      {/* Join Button */}

      {creator ? (
  <button className="join-btn" disabled>
    ✅ You're an Active Creator
  </button>
) : (
  <button
    className="join-btn"
    onClick={handleJoinCreator}
  >
    🚀 Join Creator Program
  </button>
)}

      {/* Reward Rules */}

      <div className="creator-section">

        <h3>💰 Weekly Reward Rules</h3>

{/* Example
        <div className="rule-card">
          <b>📅 Daily Login + Publish</b>

          <p>
            Login and publish at least one post every day.
          </p>

          <h4>₹1 per day</h4>
        </div>
 */}
        <div className="rule-card">
          <b>❤️ Best Weekly Post</b>

          <p>
            Your highest liked post of the week earns
            ₹1 per like.
          </p>

          {/* Example */}

      <div className="creator-section">

        <h3>📝 Weekly Reward Example</h3>

        <div className="example-box">

          Monday → ❤️10

          <br />

          Tuesday → ❤️12

          <br />

          Wednesday → ❤️5

          <br />

          Thursday → ❤️25

          <br />

          Friday → ❤️9

          <br />

          Saturday → ❤️15

          <br />

          <b> Sunday → ❤️32 </b>

          <hr />

          Best Weekly Post

          <b> ₹32</b>

         

          <h4>Total Weekly Reward <br /> = ₹32</h4>

        </div>

      </div>

        </div>

        <div className="rule-card">
          <b>💼 Wallet</b>

          <p>
            All creator rewards are credited directly to your
            Eyal Wallet.
            <br />
            *Rewards may subject to change in future.
          </p>
        </div>

      </div>

      

      {/* Leaderboard */}

      <h3 className="leader-title">
        🏅 Current Leaderboard
      </h3>

      {!list.length ? (
        <p className="center">
          No creators yet. Be the first! 🚀
        </p>
      ) : (
        <>
          {/* Winner */}

          <div className="winner-card">

            <div className="winner-badge">
              🥇 Current Leader
            </div>

            <div className="winner-name">
              {list[0].name}
            </div>

            <div className="winner-likes">
              ❤️ {list[0]["total likes"]} Likes
            </div>

            <div className="winner-week">
              {formatWeek(
                list[0]["start date"],
                list[0]["end date"]
              )}
            </div>

          </div>

          {/* Others */}

          <div className="leader-list">

            {list.slice(1).map((creator, index) => (

              <div
                key={index}
                className="leader-row"
              >

                <div className="leader-rank">
                  #{index + 2}
                </div>

                <div className="leader-info">

                  <div className="leader-name">
                    {creator.name}
                  </div>

                  <div className="leader-week">
                    {formatWeek(
                      creator["start date"],
                      creator["end date"]
                    )}
                  </div>

                </div>

                <div className="leader-likes">
                  ❤️ {creator["total likes"]}
                </div>

              </div>

            ))}

          </div>

        </>
      )}

      <div className="creator-footer">

        Rewards are credited to the Eyal Wallet after every
        weekly creator cycle.

      </div>

    </div>
  );
}